const ShimmerUI = () => {
    return (
        <div className="mt-5 md:mx-5 md:px-3">
              <section className="table__body shadow">
                    <table>
                        <thead>
                            <tr>
                                <th className="p-3 text-sm font-semibold text-left"></th>
                                <th className="p-3 text-sm font-semibold text-left"></th>
                                <th className="p-3 text-sm font-semibold text-left"></th>
                                <th className="p-3 text-sm font-semibold text-left"></th>
                                <th className="p-3 text-sm font-semibold text-left"></th>
                                <th className="p-3 text-sm font-semibold text-left"></th>
                                <th className="p-3 text-sm font-semibold text-left"></th>
                                <th className="p-3 text-sm font-semibold text-left"></th>
                                <th className="p-3 text-sm font-semibold text-left"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="animate">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className="animate">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className="animate">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className="animate">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className="animate">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className="animate">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className="animate">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className="animate">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className="animate">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            
                        </tbody>
                    </table>
                </section>
        </div>
      
    )
}

export default ShimmerUI;